import { api } from "../context/AuthContext";

// Consuma l'endpoint SSE /viki/chat/stream: chiama onDelta per ogni pezzo
// di testo visibile e restituisce il payload finale (identico a /viki/chat).
export async function streamVikiChat(payload, { onDelta } = {}) {
  const res = await fetch(`${api.defaults.baseURL}/viki/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok || !res.body) throw new Error(`stream ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let final = null;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) !== -1) {
      const raw = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      const line = raw.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      let ev;
      try { ev = JSON.parse(line.slice(6)); } catch { continue; }
      if (ev.t === "delta" && ev.c) onDelta?.(ev.c);
      else if (ev.t === "final") final = ev;
      else if (ev.t === "error") throw new Error(ev.message || "errore stream");
    }
  }
  if (!final) throw new Error("stream incompleto");
  return final;
}
